import { IListagemDeCustos } from "../../../Interfaces/AssistenciaTecnica/CustoOficialRelatoriosBI/CustoOficialRelatoriosBI";
import {
    ListagemDeCustosService,
    RemocaoDeCustosService,
    getCustosService,
    CadastroDeCustosService,
    AtualizacaoDeCustosService,
} from "../../../Services/AssistenciaTecnica/CustoOficialRelatoriosBI/CustoOficialRelatoriosBIService";
import { Controller } from "../../Controller";

export async function ListagemDeCustosController() {
    return Controller(ListagemDeCustosService());
}

export async function CadastroDeCustosController(
    requestBody: IListagemDeCustos
) {
    return Controller(CadastroDeCustosService(requestBody));
}

export async function AtualizacaoDeCustosController(
    requestBody: Array<IListagemDeCustos>
) {
    return Controller(AtualizacaoDeCustosService(requestBody));
}

export async function getCustosController(ID_CUSTO: number) {
    return Controller(getCustosService(ID_CUSTO));
}

export async function RemocaoDeCustosController(ID: number) {
    return Controller(RemocaoDeCustosService(ID));
}
